module.exports = __webpack_public_path__ + "static/img/customtextAdd.5f1fdd2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/customtextAdd.svg
// module id = /s4b
// module chunks = 3